<template>
    <div>
        <tabs-header-mobile
            route-to-name="SupplierProductsEdit"
            title="Характеристики"
        />

        <form class="product-form supplier-tab">
            <div
                class="cabinet-form-group"
                :class="{
                    error:
                        $v.product.category.$dirty &&
                        $v.product.category.$invalid
                }"
            >
                <label class="cabinet-form-group__label required"
                    >Категория</label
                >
                <select-picker
                    :current-value="product.category"
                    :options="categories"
                    key-value="CategoryID"
                    key-title="Name"
                    :classes="['select', 'select--product-form']"
                    @onChange="onSelectPickerChange('category', $event)"
                />
                <div
                    v-if="
                        $v.product.category.$dirty &&
                            $v.product.category.$invalid
                    "
                    class="error-label"
                >
                    Поле необходимо заполнить
                </div>
            </div>

            <div
                class="cabinet-form-group"
                :class="{
                    error: $v.product.type.$dirty && $v.product.type.$invalid
                }"
            >
                <label class="cabinet-form-group__label required"
                    >Вид изделия</label
                >
                <select-picker
                    :current-value="product.type"
                    :options="typeByCategory"
                    key-value="TypeID"
                    key-title="Name"
                    :classes="['select', 'select--product-form']"
                    @onChange="onSelectPickerChange('type', $event)"
                />
                <div
                    v-if="$v.product.type.$dirty && $v.product.type.$invalid"
                    class="error-label"
                >
                    Поле необходимо заполнить
                </div>
            </div>

            <div
                class="cabinet-form-group"
                :class="{
                    error: $v.product.type.$dirty && $v.product.type.$invalid
                }"
            >
                <label class="cabinet-form-group__label required"
                    >Материал</label
                >
                <select-picker
                    :current-value="product.material"
                    :options="materials"
                    key-value="MaterialID"
                    key-title="Name"
                    :classes="['select', 'select--product-form']"
                    @onChange="onSelectPickerChange('material', $event)"
                />
                <div
                    v-if="
                        $v.product.material.$dirty &&
                            $v.product.material.$invalid
                    "
                    class="error-label"
                >
                    Поле необходимо заполнить
                </div>
            </div>

            <div
                class="cabinet-form-group"
                :class="{
                    error: $v.product.brand.$dirty && $v.product.brand.$invalid
                }"
            >
                <label class="cabinet-form-group__label required">Бренд</label>
                <select-picker
                    :current-value="product.brand"
                    :options="brands"
                    key-value="BrandID"
                    key-title="BrandName"
                    :classes="['select', 'select--product-form']"
                    :disabled="true"
                    @onChange="onSelectPickerChange('brand', $event)"
                />
                <div
                    v-if="$v.product.brand.$dirty && $v.product.brand.$invalid"
                    class="error-label"
                >
                    Поле необходимо заполнить
                </div>
            </div>

            <div class="cabinet-form-group">
                <label class="cabinet-form-group__label" for="code"
                    >Артикул производителя</label
                >
                <input
                    id="code"
                    v-model="product.article"
                    type="text"
                    class="cabinet-form-group__input"
                    :class="{
                        error:
                            $v.product.article.$dirty &&
                            $v.product.article.$invalid
                    }"
                />
                <div
                    v-if="
                        $v.product.article.$dirty && $v.product.article.$invalid
                    "
                    class="error-label"
                >
                    Введите не более 50 символов
                </div>
            </div>

            <div class="cabinet-form-group">
                <label class="cabinet-form-group__label" for="name"
                    >Название изделия</label
                >
                <input
                    id="name"
                    v-model="product.name"
                    type="text"
                    class="cabinet-form-group__input"
                    :class="{
                        error:
                            $v.product.name.$dirty && $v.product.name.$invalid
                    }"
                />
                <div
                    v-if="$v.product.name.$dirty && $v.product.name.$invalid"
                    class="error-label"
                >
                    Введите не более 500 символов
                </div>
            </div>

            <div class="cabinet-form-group">
                <div
                    class="cabinet-form-group__label-wrap d-flex justify-content-between"
                >
                    <label class="cabinet-form-group__label">Коллекция</label>
                    <span
                        class="cabinet-form-group__label blue pointer"
                        @click="openCreateCollection"
                        >Создать новую</span
                    >
                </div>

                <select-picker
                    :current-value="product.collection"
                    :options="collectionsByBrand"
                    key-value="CollectionID"
                    key-title="Name"
                    empty-option-title="Нет коллекции"
                    :classes="['select', 'select--product-form']"
                    @onChange="onSelectPickerChange('collection', $event)"
                />
            </div>

            <create-collection
                :is-open="isCreateCollectionOpen"
                :brand-id="product.brand"
                @closeModal="isCreateCollectionOpen = false"
                @onCreateCollection="product.collection = $event"
            />

            <div v-if="isGarnitureFieldAvailable" class="cabinet-form-group">
                <label class="cabinet-form-group__label" for="garniture"
                    >Артикул гарнитура</label
                >
                <garniture-autocomplete
                    :key="product.brand"
                    :initial-garniture="product.garniture || {}"
                    :brand-id="product.brand"
                    @garnitureChange="onGarnitureChange"
                />
                <div
                    v-if="supplierSetsErrors.setItemsToSet.error"
                    class="error-label"
                >
                    {{ supplierSetsErrors.setItemsToSet.error }}
                </div>
                <div
                    v-if="supplierSetsErrors.createSet.error"
                    class="error-label"
                >
                    {{ supplierSetsErrors.createSet.error }}
                </div>
            </div>

            <div v-if="!isWatchCategory" class="cabinet-form-group">
                <label class="cabinet-form-group__label" for="size"
                    >Доступные размеры</label
                >
                <input
                    id="size"
                    v-model="product.size"
                    type="text"
                    class="cabinet-form-group__input"
                    :class="{
                        error:
                            $v.product.size.$dirty && $v.product.size.$invalid
                    }"
                />
                <div
                    v-if="$v.product.size.$dirty && $v.product.size.$invalid"
                    class="error-label"
                >
                    Введите не более 150 символов
                </div>
            </div>

            <div v-if="finenessByMaterial.length" class="cabinet-form-group">
                <label class="cabinet-form-group__label">Проба</label>
                <select-picker
                    :current-value="product.fineness"
                    :options="finenessByMaterial"
                    key-value="FinenessID"
                    key-title="Value"
                    :classes="['select', 'select--product-form']"
                    @onChange="onSelectPickerChange('fineness', $event)"
                />
            </div>

            <div v-if="colors.length" class="cabinet-form-group">
                <label class="cabinet-form-group__label">Цвет металла</label>
                <select-picker
                    :current-value="product.color"
                    :options="colors"
                    key-value="ColorID"
                    key-title="Name"
                    :classes="['select', 'select--product-form']"
                    @onChange="onSelectPickerChange('color', $event)"
                />
            </div>

            <template v-if="isWatchCategory">
                <div v-if="caseShapes.length" class="cabinet-form-group">
                    <label class="cabinet-form-group__label"
                        >Форма корпуса</label
                    >
                    <select-picker
                        :current-value="product.itemWatch.CaseShapeID"
                        :options="caseShapes"
                        key-value="CaseShapeID"
                        key-title="Name"
                        :classes="['select', 'select--product-form']"
                        @onChange="
                            onItemWatchSelectPickerChange('CaseShapeID', $event)
                        "
                    />
                </div>

                <div class="cabinet-form-group">
                    <label class="cabinet-form-group__label" for="CaseSize"
                        >Размер корпуса</label
                    >
                    <input
                        id="CaseSize"
                        v-model="product.itemWatch.CaseSize"
                        type="text"
                        class="cabinet-form-group__input"
                        :class="{
                            error:
                                $v.product.itemWatch.CaseSize.$dirty &&
                                $v.product.itemWatch.CaseSize.$invalid
                        }"
                    />
                    <div
                        v-if="
                            $v.product.itemWatch.CaseSize.$dirty &&
                                $v.product.itemWatch.CaseSize.$invalid
                        "
                        class="error-label"
                    >
                        Введите не более 50 символов
                    </div>
                </div>

                <div class="cabinet-form-group">
                    <label class="cabinet-form-group__label" for="box_height"
                        >Высота корпуса</label
                    >

                    <div class="product-form__unit product-form__unit--w50">
                        <input
                            id="box_height"
                            v-model="product.itemWatch.CaseHeight"
                            type="text"
                            class="cabinet-form-group__input product-form__unit-input"
                            :class="{
                                error:
                                    $v.product.itemWatch.CaseHeight.$dirty &&
                                    $v.product.itemWatch.CaseHeight.$invalid
                            }"
                        />
                        <div class="product-form__unit-text">мм</div>
                    </div>
                    <div
                        v-if="
                            $v.product.itemWatch.CaseHeight.$dirty &&
                                $v.product.itemWatch.CaseHeight.$invalid
                        "
                        class="error-label"
                    >
                        Введите число не более 9 символов
                    </div>
                </div>

                <div class="cabinet-form-group">
                    <label class="cabinet-form-group__label" for="Mechanism"
                        >Механизм</label
                    >
                    <input
                        id="Mechanism"
                        v-model="product.itemWatch.Mechanism"
                        type="text"
                        class="cabinet-form-group__input"
                        :class="{
                            error:
                                $v.product.itemWatch.Mechanism.$dirty &&
                                $v.product.itemWatch.Mechanism.$invalid
                        }"
                    />
                    <div
                        v-if="
                            $v.product.itemWatch.Mechanism.$dirty &&
                                $v.product.itemWatch.Mechanism.$invalid
                        "
                        class="error-label"
                    >
                        Введите не более 50 символов
                    </div>
                </div>

                <div class="cabinet-form-group">
                    <label class="cabinet-form-group__label" for="MechanismType"
                        >Тип механизма</label
                    >
                    <input
                        id="MechanismType"
                        v-model="product.itemWatch.MechanismType"
                        type="text"
                        class="cabinet-form-group__input"
                        :class="{
                            error:
                                $v.product.itemWatch.MechanismType.$dirty &&
                                $v.product.itemWatch.MechanismType.$invalid
                        }"
                    />
                    <div
                        v-if="
                            $v.product.itemWatch.MechanismType.$dirty &&
                                $v.product.itemWatch.MechanismType.$invalid
                        "
                        class="error-label"
                    >
                        Введите не более 50 символов
                    </div>
                </div>

                <div class="cabinet-form-group">
                    <label
                        class="cabinet-form-group__label"
                        for="MechanismFeatures"
                        >Дополнительные функции</label
                    >
                    <input
                        id="MechanismFeatures"
                        v-model="product.itemWatch.MechanismFeatures"
                        type="text"
                        class="cabinet-form-group__input"
                        :class="{
                            error:
                                $v.product.itemWatch.MechanismFeatures.$dirty &&
                                $v.product.itemWatch.MechanismFeatures.$invalid
                        }"
                    />
                    <div
                        v-if="
                            $v.product.itemWatch.MechanismFeatures.$dirty &&
                                $v.product.itemWatch.MechanismFeatures.$invalid
                        "
                        class="error-label"
                    >
                        Введите не более 50 символов
                    </div>
                </div>

                <div class="cabinet-form-group">
                    <label class="cabinet-form-group__label" for="MechanismInfo"
                        >Номенклатура</label
                    >
                    <input
                        id="MechanismInfo"
                        v-model="product.itemWatch.MechanismInfo"
                        type="text"
                        class="cabinet-form-group__input"
                        :class="{
                            error:
                                $v.product.itemWatch.MechanismInfo.$dirty &&
                                $v.product.itemWatch.MechanismInfo.$invalid
                        }"
                    />
                    <div
                        v-if="
                            $v.product.itemWatch.MechanismInfo.$dirty &&
                                $v.product.itemWatch.MechanismInfo.$invalid
                        "
                        class="error-label"
                    >
                        Введите не более 150 символов
                    </div>
                </div>

                <div class="cabinet-form-group">
                    <label class="cabinet-form-group__label" for="Features"
                        >Функции</label
                    >
                    <input
                        id="Features"
                        v-model="product.itemWatch.Features"
                        type="text"
                        class="cabinet-form-group__input"
                        :class="{
                            error:
                                $v.product.itemWatch.Features.$dirty &&
                                $v.product.itemWatch.Features.$invalid
                        }"
                    />
                    <div
                        v-if="
                            $v.product.itemWatch.Features.$dirty &&
                                $v.product.itemWatch.Features.$invalid
                        "
                        class="error-label"
                    >
                        Введите не более 150 символов
                    </div>
                </div>

                <div class="cabinet-form-group">
                    <label class="cabinet-form-group__label" for="BraceletWidth"
                        >Ширина ремешка</label
                    >

                    <div class="product-form__unit product-form__unit--w50">
                        <input
                            id="BraceletWidth"
                            v-model="product.itemWatch.BraceletWidth"
                            type="text"
                            class="cabinet-form-group__input product-form__unit-input"
                            :class="{
                                error:
                                    $v.product.itemWatch.BraceletWidth.$dirty &&
                                    $v.product.itemWatch.BraceletWidth.$invalid
                            }"
                        />
                        <div class="product-form__unit-text">мм</div>
                    </div>
                    <div
                        v-if="
                            $v.product.itemWatch.BraceletWidth.$dirty &&
                                $v.product.itemWatch.BraceletWidth.$invalid
                        "
                        class="error-label"
                    >
                        Введите целое число не более 10 символов
                    </div>
                </div>

                <div class="cabinet-form-group">
                    <label
                        class="cabinet-form-group__label"
                        for="BraceletMaterial"
                        >Материал ремешка</label
                    >
                    <input
                        id="BraceletMaterial"
                        v-model="product.itemWatch.BraceletMaterial"
                        type="text"
                        class="cabinet-form-group__input"
                        :class="{
                            error:
                                $v.product.itemWatch.BraceletMaterial.$dirty &&
                                $v.product.itemWatch.BraceletMaterial.$invalid
                        }"
                    />
                    <div
                        v-if="
                            $v.product.itemWatch.BraceletMaterial.$dirty &&
                                $v.product.itemWatch.BraceletMaterial.$invalid
                        "
                        class="error-label"
                    >
                        Введите не более 50 символов
                    </div>
                </div>

                <div class="cabinet-form-group">
                    <label class="cabinet-form-group__label" for="GlassType"
                        >Стекло</label
                    >
                    <input
                        id="GlassType"
                        v-model="product.itemWatch.GlassType"
                        type="text"
                        class="cabinet-form-group__input"
                        :class="{
                            error:
                                $v.product.itemWatch.GlassType.$dirty &&
                                $v.product.itemWatch.GlassType.$invalid
                        }"
                    />
                    <div
                        v-if="
                            $v.product.itemWatch.GlassType.$dirty &&
                                $v.product.itemWatch.GlassType.$invalid
                        "
                        class="error-label"
                    >
                        Введите не более 100 символов
                    </div>
                </div>

                <div class="cabinet-form-group">
                    <label class="cabinet-form-group__label" for="Battery"
                        >Элемент питания</label
                    >
                    <input
                        id="Battery"
                        v-model="product.itemWatch.Battery"
                        type="text"
                        class="cabinet-form-group__input"
                        :class="{
                            error:
                                $v.product.itemWatch.Battery.$dirty &&
                                $v.product.itemWatch.Battery.$invalid
                        }"
                    />
                    <div
                        v-if="
                            $v.product.itemWatch.Battery.$dirty &&
                                $v.product.itemWatch.Battery.$invalid
                        "
                        class="error-label"
                    >
                        Введите не более 50 символов
                    </div>
                </div>

                <div class="cabinet-form-group">
                    <label class="cabinet-form-group__label" for="DialType"
                        >Вид циферблата</label
                    >
                    <input
                        id="DialType"
                        v-model="product.itemWatch.DialType"
                        type="text"
                        class="cabinet-form-group__input"
                        :class="{
                            error:
                                $v.product.itemWatch.DialType.$dirty &&
                                $v.product.itemWatch.DialType.$invalid
                        }"
                    />
                    <div
                        v-if="
                            $v.product.itemWatch.DialType.$dirty &&
                                $v.product.itemWatch.DialType.$invalid
                        "
                        class="error-label"
                    >
                        Введите не более 50 символов
                    </div>
                </div>

                <div class="cabinet-form-group">
                    <label class="cabinet-form-group__label" for="DialColor"
                        >Цвет циферблата</label
                    >
                    <input
                        id="DialColor"
                        v-model="product.itemWatch.DialColor"
                        type="text"
                        class="cabinet-form-group__input"
                        :class="{
                            error:
                                $v.product.itemWatch.DialColor.$dirty &&
                                $v.product.itemWatch.DialColor.$invalid
                        }"
                    />
                    <div
                        v-if="
                            $v.product.itemWatch.DialColor.$dirty &&
                                $v.product.itemWatch.DialColor.$invalid
                        "
                        class="error-label"
                    >
                        Введите не более 50 символов
                    </div>
                </div>

                <div class="cabinet-form-group">
                    <label
                        class="cabinet-form-group__label"
                        for="WaterResistance"
                        >Водостойкость</label
                    >
                    <input
                        id="WaterResistance"
                        v-model="product.itemWatch.WaterResistance"
                        type="text"
                        class="cabinet-form-group__input"
                        :class="{
                            error:
                                $v.product.itemWatch.WaterResistance.$dirty &&
                                $v.product.itemWatch.WaterResistance.$invalid
                        }"
                    />
                    <div
                        v-if="
                            $v.product.itemWatch.WaterResistance.$dirty &&
                                $v.product.itemWatch.WaterResistance.$invalid
                        "
                        class="error-label"
                    >
                        Введите не более 50 символов
                    </div>
                </div>

                <div class="cabinet-form-group">
                    <label
                        class="cabinet-form-group__label"
                        for="PreciousMetalWeight"
                        >Средний вес драгметалла</label
                    >
                    <input
                        id="PreciousMetalWeight"
                        v-model="product.itemWatch.PreciousMetalWeight"
                        type="text"
                        class="cabinet-form-group__input"
                        :class="{
                            error:
                                $v.product.itemWatch.PreciousMetalWeight
                                    .$dirty &&
                                $v.product.itemWatch.PreciousMetalWeight
                                    .$invalid
                        }"
                    />
                    <div
                        v-if="
                            $v.product.itemWatch.PreciousMetalWeight.$dirty &&
                                $v.product.itemWatch.PreciousMetalWeight
                                    .$invalid
                        "
                        class="error-label"
                    >
                        Введите не более 50 символов
                    </div>
                </div>
            </template>

            <template v-if="!isWatchCategory">
                <div v-if="colors.length" class="cabinet-form-group">
                    <label class="cabinet-form-group__label"
                        >Технология изготовления</label
                    >
                    <select-picker
                        :current-value="product.technology"
                        :options="technologies"
                        key-value="TechnologyID"
                        key-title="Name"
                        :classes="['select', 'select--product-form']"
                        @onChange="onSelectPickerChange('technology', $event)"
                    />
                </div>

                <div class="cabinet-form-group">
                    <label class="cabinet-form-group__label">Тип декора</label>
                    <select-picker
                        :current-value="product.decor"
                        :options="decor"
                        key-value="DecorID"
                        key-title="Name"
                        select-width="100%"
                        :is-multiple="true"
                        :show-multi-selected-titles="true"
                        :classes="['select', 'select--product-form']"
                        @onChange="onMultiSelectPickerChange('decor', $event)"
                    />
                </div>

                <div v-if="purposesByType.length" class="cabinet-form-group">
                    <label class="cabinet-form-group__label">Назначение</label>
                    <select-picker
                        :current-value="product.purpose"
                        :options="purposesByType"
                        key-value="PurposeID"
                        key-title="Name"
                        :classes="['select', 'select--product-form']"
                        @onChange="onSelectPickerChange('purpose', $event)"
                    />
                </div>
            </template>

            <div class="cabinet-form-group">
                <label class="cabinet-form-group__label">Для кого</label>
                <select-picker
                    :current-value="product.gender"
                    :options="genders"
                    key-value="id"
                    key-title="title"
                    :classes="['select', 'select--product-form']"
                    @onChange="onSelectPickerChange('gender', $event)"
                />
            </div>

            <div class="cabinet-form-group">
                <label class="cabinet-form-group__label" for="price"
                    >Цена</label
                >
                <div
                    class="product-form__price-wrap-group flex flex-justify-sb flex-align-center"
                >
                    <div class="product-form__price-wrap">
                        <input
                            id="price"
                            v-model="product.price"
                            type="number"
                            min="0"
                            class="cabinet-form-group__input product-form__price"
                            :class="{
                                error:
                                    $v.product.price.$dirty &&
                                    $v.product.price.$invalid
                            }"
                        />
                    </div>

                    <select-picker
                        :current-value="product.priceUnit"
                        :options="priceUnitOptions"
                        key-value="id"
                        key-title="title"
                        :classes="['select', 'select--product-price']"
                        :disabled="isWatchCategory"
                        @onChange="onSelectPickerChange('priceUnit', $event)"
                    />
                </div>
                <div
                    v-if="$v.product.price.$dirty && $v.product.price.$invalid"
                    class="error-label"
                >
                    Введите число от 0 до 99999999.99
                </div>
            </div>

            <div v-if="!isWatchCategory" class="cabinet-form-group">
                <label class="cabinet-form-group__label" for="weight"
                    >Вес</label
                >
                <div class="cabinet-form-group--input-wrap">
                    <div class="position-relative w-50">
                        <input
                            id="weight"
                            v-model="product.weight"
                            type="number"
                            min="0"
                            class="cabinet-form-group__input cabinet-form-group__input--icon"
                            :class="{
                                error:
                                    $v.product.weight.$dirty &&
                                    $v.product.weight.$invalid
                            }"
                        />
                        <div class="cabinet-form-group__icon">гр</div>
                    </div>
                </div>

                <div
                    v-if="
                        $v.product.weight.$dirty && $v.product.weight.$invalid
                    "
                    class="error-label"
                >
                    Введите число от 0 до 9999.99
                </div>
            </div>

            <div class="cabinet-form-group">
                <label class="cabinet-form-group__label" for="SupplierURL"
                    >Ссылка на страницу изделия</label
                >
                <div class="cabinet-form-group--input-wrap">
                    <input
                        id="SupplierURL"
                        v-model="product.supplierurl"
                        type="text"
                        min="0"
                        class="cabinet-form-group__input cabinet-form-group__input--icon"
                    />
                </div>
            </div>

            <div class="cabinet-form-group">
                <label class="cabinet-form-group__label" for="descr"
                    >Описание</label
                >
                <textarea
                    id="descr"
                    v-model="product.descr"
                    class="cabinet-form-group__textarea cabinet-form-group__textarea--resizable"
                    :class="{
                        error:
                            $v.product.descr.$dirty && $v.product.descr.$invalid
                    }"
                ></textarea>

                <div
                    v-if="$v.product.descr.$dirty && $v.product.descr.$invalid"
                    class="error-label"
                >
                    Введите не более 10 000 символов
                </div>
            </div>

            <div class="product-form__btn-wrap">
                <button
                    type="button"
                    class="cabinet-btn product-form__btn"
                    :class="{ loading }"
                    :disabled="!product.id"
                    @click="saveProduct()"
                >
                    Сохранить изменения
                </button>
            </div>
        </form>
    </div>
</template>

<script>
import SelectPicker from '@/components/Elements/SelectPicker'
import TabsHeaderMobile from '@/components/Cabinet/Tabs/TabsHeaderMobile'
import CreateCollection from '@/components/Cabinet/Supplier/Collection/CreateCollection'
import GarnitureAutocomplete from '@/components/Cabinet/Supplier/Product/GarnitureAutocomplete.vue'
import setGarniture from '@/mixins/setGarnitureToProduct'
import { mapState, mapGetters, mapActions } from 'vuex'
import {
    required,
    minLength,
    maxLength,
    between,
    integer
} from 'vuelidate/lib/validators'

const validations = {
    product: {
        category: { required },
        type: { required },
        material: { required },
        brand: { required },
        article: {
            maxLength: maxLength(50)
        },
        name: {
            maxLength: maxLength(500)
        },
        size: {
            maxLength: maxLength(150)
        },
        price: {
            required,
            between: between(0, 99999999.99)
        },
        weight: {
            between: between(0, 9999.99)
        },
        descr: {
            maxLength: maxLength(10000)
        },
        itemWatch: {
            CaseShapeID: { integer },
            CaseSize: { maxLength: maxLength(50) },
            CaseHeight: {
                between: between(0, 99999999.99),
                maxLength: maxLength(10)
            },
            Mechanism: { maxLength: maxLength(50) },
            MechanismType: { maxLength: maxLength(50) },
            MechanismFeatures: { maxLength: maxLength(50) },
            MechanismInfo: { maxLength: maxLength(150) },
            Features: { maxLength: maxLength(150) },
            BraceletWidth: { integer, maxLength: maxLength(10) },
            BraceletMaterial: { maxLength: maxLength(50) },
            GlassType: { maxLength: maxLength(100) },
            Battery: { maxLength: maxLength(50) },
            DialType: { maxLength: maxLength(50) },
            DialColor: { maxLength: maxLength(50) },
            WaterResistance: { maxLength: maxLength(50) },
            PreciousMetalWeight: { maxLength: maxLength(50) }
        }
    }
}

export default {
    name: 'EditSpecification',
    components: {
        TabsHeaderMobile,
        SelectPicker,
        CreateCollection,
        GarnitureAutocomplete
    },
    mixins: [setGarniture],
    data() {
        return {
            product: {
                id: '', //indicate product was loaded
                category: '',
                type: '',
                material: '',
                collection: '',
                fineness: '',
                color: '',
                technology: '',
                decor: [],
                purpose: '',
                gender: '',
                priceUnit: 1,
                brand: '',
                article: '',
                name: '',
                size: '',
                price: 0,
                weight: '',
                supplierurl: '',
                descr: '',
                garniture: {
                    id: '',
                    set_article: ''
                },
                itemWatch: {
                    CaseShapeID: '',
                    CaseSize: '',
                    CaseHeight: '',
                    Mechanism: '',
                    MechanismType: '',
                    MechanismFeatures: '',
                    MechanismInfo: '',
                    Features: '',
                    BraceletWidth: '',
                    BraceletMaterial: '',
                    GlassType: '',
                    Battery: '',
                    DialType: '',
                    DialColor: '',
                    WaterResistance: '',
                    PreciousMetalWeight: ''
                }
            },
            isCreateCollectionOpen: false,
            loading: false
        }
    },
    computed: {
        ...mapGetters('supplierProducts', ['getFormattedProduct']),

        ...mapState('categories', ['categories']),
        ...mapState('types', ['types']),
        ...mapState('caseShapes', ['caseShapes']),
        ...mapGetters('types', ['getTypeByCategory']),
        ...mapState('materials', ['materials']),
        ...mapState('finenesses', ['finenesses']),
        ...mapGetters('finenesses', ['getFinenessByMaterial']),
        ...mapState('colors', ['colors']),
        ...mapState('technologies', ['technologies']),
        ...mapState('decor', ['decor']),
        ...mapState('purposes', ['purposes']),
        ...mapGetters('purposes', ['getPurposesByType']),
        ...mapState('genders', ['genders']),
        ...mapState('supplierBrand', ['brands']),
        ...mapGetters('supplierCollections', ['getCollectionsByBrand']),
        ...mapState('other', ['priceUnitOptions']),
        ...mapState('supplierSets', {
            supplierSetsErrors: 'errors'
        }),
        typeByCategory() {
            return this.getTypeByCategory(this.product.category)
        },
        finenessByMaterial() {
            return this.getFinenessByMaterial(this.product.material)
        },
        purposesByType() {
            return this.getPurposesByType(this.product.type)
        },
        collectionsByBrand() {
            return this.getCollectionsByBrand(this.product.brand)
        },
        isGarnitureFieldAvailable() {
            return this.product.category == 1 //"Украшения"
        },
        isWatchCategory() {
            return this.product.category === 5 //Часы
        }
    },
    validations,
    watch: {
        getFormattedProduct: {
            handler: function(val) {
                if (!this.product.id && Object.keys(val).length) {
                    this.setProductFields()
                }
            },
            deep: true
        }
    },
    mounted() {
        if (Object.keys(this.getFormattedProduct).length) {
            this.setProductFields()
        }
    },
    methods: {
        ...mapActions('supplierProducts', ['updateProduct', 'getProduct']),
        ...mapActions('supplierSets', [
            'setItemsToSet',
            'createSet',
            'removeItemsFromSet',
            'resetErrors'
        ]),
        setProductFields() {
            this.product = {
                ...this.getFormattedProduct
            }
        },
        onSelectPickerChange(type, val) {
            this.product[type] = parseInt(val)

            switch (type) {
                case 'category':
                    this.product.type = ''
                    break
                case 'material':
                    this.product.fineness = ''
                    break
                case 'type':
                    this.product.purpose = ''
                    break
            }
        },
        onMultiSelectPickerChange(type, val) {
            this.product[type] = val
        },
        onItemWatchSelectPickerChange(type, val) {
            this.product.itemWatch[type] = parseInt(val)
        },
        openCreateCollection() {
            if (this.product.brand) {
                this.isCreateCollectionOpen = !this.isCreateCollectionOpen
            } else {
                this.$notify({
                    title: 'Бренд не выбран',
                    type: 'error'
                })
            }
        },
        async saveProduct() {
            if (this.loading) return

            this.$v.$touch()

            if (!this.$v.$invalid) {
                this.loading = true

                let data = {
                    BrandID: this.product.brand,
                    CategoryID: this.product.category,
                    TypeID: this.product.type,
                    TechnologyID: this.product.technology || undefined,
                    Article: this.product.article,
                    Weight: this.product.weight
                        ? parseFloat(this.product.weight)
                        : undefined,
                    Size: this.product.size,
                    Price: this.product.price,
                    PriceUnit: this.product.priceUnit,
                    Name: this.product.name,
                    SupplierURL: decodeURI(this.product.supplierurl),
                    Description: this.product.descr,
                    CollectionID: this.product.collection || null,
                    MaterialID: this.product.material,
                    ColorID: this.product.color || undefined,
                    FinenessID: this.product.fineness || undefined,
                    Decor: this.product.decor,
                    Purposes: this.product.purpose
                        ? new Array(1).fill(this.product.purpose)
                        : undefined
                }

                if (this.isWatchCategory) {
                    let itemWatchFieldsArr = Object.keys(this.product.itemWatch)

                    itemWatchFieldsArr.forEach(field => {
                        let val = this.product.itemWatch[field]
                        data = {
                            ...data,
                            [field]: val
                        }
                    })
                }

                if (this.product.gender) {
                    data.Gender = this.product.gender
                }

                try {
                    let payload = {
                        id: this.product.id,
                        type: 'main',
                        data
                    }
                    await this.updateProduct(payload)

                    this.clearSupplierCatalogFilterDict()

                    this.$notify({
                        title: 'Продукт успешно обновлен',
                        type: 'success'
                    })
                } catch (e) {
                    console.log(e)
                    this.$notify({
                        title: 'Ошибка',
                        type: 'error'
                    })
                }

                if (this.isGarnitureFieldAvailable) {
                    await this.setGarniture(this.product.id)
                }

                try {
                    await this.getProduct(this.product.id)
                    this.setProductFields()
                } catch (e) {
                    console.log(e)
                }

                this.loading = false
            } else {
                this.$notify({
                    title: 'Форма заполнена некорректно',
                    type: 'error'
                })
            }
        },
        onGarnitureChange(val) {
            this.product.garniture = val
        }
    }
}
</script>
